import { createStore } from 'zustand/vanilla';

const EMPTY = {
    sessionIdPublic: null,
    sessionIdPrivate: null,
    topicsSuffix: null,
    expiration: null,
    sessionCreated: false,
    mode: null,
    // Per-session broker token, when the backend issues one. Absent against an
    // older backend, in which case the static credentials keep being used.
    token: null,
};

export function createSessionStore() {
    const store = createStore((set) => ({
        ...EMPTY,
        connected: false,

        sessionJoined: ({ session_id_public, session_id_private, topics_suffix, expiration, token }) => {
            set({
                sessionIdPublic: session_id_public || null,
                sessionIdPrivate: session_id_private || null,
                topicsSuffix: topics_suffix || null,
                expiration: expiration || null,
                sessionCreated: true,
                mode: session_id_private ? 'editor' : 'observer',
                token: token || null,
            });
        },
        // Dropped when the broker rejects it, so the transport falls back to the
        // static credentials rather than retrying something already refused.
        tokenRejected: () => set({ token: null }),
        sessionEnded: () => set({ ...EMPTY }),
        setConnected: (value) => set({ connected: !!value }),
    }));
    return { store };
}
